import { Box, Caption, Heading } from "@bcc-ui/ui-components";
import classNames from "classnames";
import React from "react";

import style from "./card.scss";

interface Props {
    icon?: React.ReactNode;
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    content?: React.ReactNode;
    buttons?: React.ReactNode;
    statusBadge?: React.ReactNode;
    onClick?: () => void;
    className?: string;
}

export const Card = (props: Props) => {
    return (
        <Box
            columnLayout
            padding={"Sm"}
            justifyContent={"SpaceBetween"}
            onClick={props.onClick}
            className={classNames(style.card, props.onClick && style.clickableCard, props.className)}
        >
            {props.statusBadge && <Box className={style.statusBadge}>{props.statusBadge}</Box>}
            <Box columnLayout>
                {props.icon && (
                    <Box columnLayout paddingBottom={"Xs"}>
                        {props.icon}
                    </Box>
                )}

                {props.title && typeof props.title === "string" ? (
                    <Heading variant={"SUBTITLE_1"} disableTopSpacing disableBottomSpacing>
                        {props.title}
                    </Heading>
                ) : (
                    props.title
                )}

                {props.subtitle && (
                    <Box gap={"Xxxs"} className={style.subtitleContainer}>
                        {props.subtitle}
                    </Box>
                )}

                {props.content && (
                    <Box paddingTop={"Xxs"} paddingBottom={"Sm"}>
                        {typeof props.content === "string" ? (
                            <Caption greyTextStyle>{props.content}</Caption>
                        ) : (
                            props.content
                        )}
                    </Box>
                )}
            </Box>

            {props.buttons && (
                <Box
                    verticalAlignment={"Center"}
                    gap={"Md"}
                    onClick={(e) => e.stopPropagation()}
                    className={style.buttonContainer}
                >
                    {props.buttons}
                </Box>
            )}
        </Box>
    );
};
